import $http from '../../axios';
import {Notification} from 'element-ui';
import moment from "moment";

/**
 * Descargar plantilla
 */
export async function downloadTemplateIncorporateAccountingMovements({}) {
    await $http({
        url: '/api/descargar-plantilla-incorporacion-contable',
        method: 'GET',
        responseType: 'blob'
    })
        .then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'plantilla_movimientos_contables.xlsx');
            document.body.appendChild(link);
            link.click();
        })
        .catch(error => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 3000,
                customClass: 'notification-box'
            });
        });
}

/**
 * Incorporar operaciones contables.
 */
export async function incorporateAccountingMovements({commit, state}) {
    commit('setPreloader', true);

    let form_data = new FormData();

    for (let key in state.data) {
        form_data.append(key, state.data[key]);
    }

    commit('setDisableIncorporationToData', 1);

    await $http.post('/api/incorporar-moviminetos-contables', form_data)
        .then((response) => {
            commit('setPreloader', false);

            if (!!state.data.only_validation) {

                let errors = response.data.data.errors

                if (!errors.length) {
                    Notification.success({
                        title: 'Éxito',
                        message: 'validando archivo en segundo plano... ',
                        type: 'success',
                        duration: 5000,
                        customClass: 'notification-box',
                    });
                } else {
                    Notification.error({
                        title: 'Error',
                        message: 'Existen inconsistencias en el archivo cargado',
                        type: 'error',
                        duration: 5000,
                        customClass: 'notification-box',
                    });
                }
            } else {
                Notification.success({
                    title: 'Éxito',
                    message: response.data.message,
                    type: 'success',
                    duration: 5000,
                    customClass: 'notification-box',
                });
                commit('resetData');
            }
        })
        .catch((error) => {
            commit('setPreloader', false);
            console.error(error);

            Notification.error({
                title: 'Error',
                message: 'Error al procesar el archivo',
                type: 'error',
                duration: 5000,
                customClass: 'notification-box',
            });
        });
}

/**
 * Eliminar todos los documentos de un tipo de comprobante.
 */
export async function deleteAllDocumentsByVoucherTypeId({commit, state}) {
    commit('setPreloader', true);

    await $http.post('/api/eliminar-documentos-tipo-comprobante', state.data)
        .then((response) => {
            commit('setPreloader', false);

            Notification.success({
                title: 'Éxito',
                message: response.data.message,
                type: 'success',
                duration: 5000,
                customClass: 'notification-box',
            });

        })
        .catch((error) => {
            commit('setPreloader', false);
            console.error(error);

            Notification.error({
                title: 'Error',
                message: 'Error al eliminar los documentos',
                type: 'error',
                duration: 5000,
                customClass: 'notification-box',
            });
        });
}



// WEBPACK FOOTER //
// ./src/modules/incorporate_accounting_movements/actions.js